
import { prop, Vue } from "vue-class-component";

class Prop {
  arrowPosition = prop<string>({
    default: "right-6",
    type: String
  });
  overlayWidth = prop<string>({
    default: "225px",
    type: String
  });
  isContentHavePadding = prop<boolean>({
    default: true,
    type: Boolean
  });
}

export default class CustomOverlay extends Vue.with(Prop) {
  isOpen = false;
  triggerRef: HTMLElement | null = null;
  overlayRef: HTMLElement | null = null;

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  }

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  handleClickOutside(event: MouseEvent) {
    const target = event.target as Node;
    if (
      this.overlayRef &&
      !this.overlayRef.contains(target) &&
      this.triggerRef &&
      !this.triggerRef.contains(target)
    ) {
      this.isOpen = false;
    }
  }
}
